'use client'
import {
   AiMlIcon,
   AndroiudIcon,
   AngularIcon,
   BlockChainIcon,
   CustomSoftwareIcon,
   EcommIcon,
   FlutterIcons,
   IphoneIcon,
   JavaIcon,
   LaravelIcons,
   MoboIcon,
   NodeJsIcon,
   PhPIcon,
   PythonDevIcon,
   QAIcons,
   ReactJsIcons,
   UiIcons,
   VueIcon,
   WebAppIcon,
   WebDesignIcons,
} from '@/svgs'
import Link from 'next/link'
import React from 'react'

export default function ServicesSection() {
   return (
      <section className="section_secondary_bg">
         <div className="container">
            <h2 className="section_heading_title mb-3">
               Our Software Development Services
            </h2>
            <p className="info_tell_description cs-text-primary mb-4">
               We deliver client-focused software solutions built on in-depth
               market research, ensuring exceptional performance even under
               high-demand conditions. As a dedicated software development
               partner, we understand our clients' unique needs and provide
               tailored solutions at competitive prices.
            </p>
            <div className="ind-travel-section">
               <div className="ind-travel-wrap ai-ml-wrap">
                  <Link
                     href="/services/ai-ml-development-company"
                     className="ind-travel-icon-content"
                  >
                     <div className="ind-travel-icon">
                        <AiMlIcon />
                     </div>
                     <p className="ind-travel-text">AI & ML Development</p>
                  </Link>
                  <Link
                     href="/industries/e-commerce-software-development-solutions"
                     className="ind-travel-icon-content"
                  >
                     <div className="ind-travel-icon">
                        <EcommIcon />
                     </div>
                     <p className="ind-travel-text">Ecommerce Development</p>
                  </Link>
                  <Link
                     href="/services/web-application-development-company"
                     className="ind-travel-icon-content"
                  >
                     <div className="ind-travel-icon">
                        <WebAppIcon />
                     </div>
                     <p className="ind-travel-text">
                        Web Application Development
                     </p>
                  </Link>
                  <Link
                     href="/services/custom-software-development-company"
                     className="ind-travel-icon-content"
                  >
                     <div className="ind-travel-icon">
                        <CustomSoftwareIcon />
                     </div>
                     <p className="ind-travel-text">
                        Custom Software Development
                     </p>
                  </Link>
                  <Link
                     href="/technologies/backend/php-application-development-company"
                     className="ind-travel-icon-content"
                  >
                     <div className="ind-travel-icon">
                        <PhPIcon />
                     </div>
                     <p className="ind-travel-text">PHP Development</p>
                  </Link>
                  <Link
                     href="/technologies/frontend/angular-development-company"
                     className="ind-travel-icon-content"
                  >
                     <div className="ind-travel-icon">
                        <AngularIcon />
                     </div>
                     <p className="ind-travel-text">Angular Development</p>
                  </Link>
                  <Link
                     href="/technologies/backend/python-development-company"
                     className="ind-travel-icon-content"
                  >
                     <div className="ind-travel-icon">
                        <PythonDevIcon />
                     </div>
                     <p className="ind-travel-text">Python Development</p>
                  </Link>
                  <Link
                     href="/technologies/backend/nodejs-application-development-company"
                     className="ind-travel-icon-content"
                  >
                     <div className="ind-travel-icon">
                        <NodeJsIcon />
                     </div>
                     <p className="ind-travel-text">NodeJS Development</p>
                  </Link>
                  <Link
                     href="/services/blockchain-development-company"
                     className="ind-travel-icon-content"
                  >
                     <div className="ind-travel-icon">
                        <BlockChainIcon />
                     </div>
                     <p className="ind-travel-text">Blockchain Development</p>
                  </Link>
                  <Link
                     href="/technologies/backend/java-application-development-company"
                     className="ind-travel-icon-content"
                  >
                     <div className="ind-travel-icon">
                        <JavaIcon />
                     </div>
                     <p className="ind-travel-text">java Development</p>
                  </Link>
                  <Link
                     href="/technologies/frontend/react-development-company"
                     className="ind-travel-icon-content"
                  >
                     <div className="ind-travel-icon">
                        <ReactJsIcons />
                     </div>
                     <p className="ind-travel-text">React JS Development</p>
                  </Link>
                  <Link
                     href="/technologies/backend/laravel-application-development-company"
                     className="ind-travel-icon-content"
                  >
                     <div className="ind-travel-icon">
                        <LaravelIcons />
                     </div>
                     <p className="ind-travel-text">Laravel Development</p>
                  </Link>
                  <Link
                     href="/services/mobile-application-development-company"
                     className="ind-travel-icon-content"
                  >
                     <div className="ind-travel-icon">
                        <MoboIcon />
                     </div>
                     <p className="ind-travel-text">
                        Mobile Application Development
                     </p>
                  </Link>
                  <Link
                     href="/technologies/mobile/flutter-development-company"
                     className="ind-travel-icon-content"
                  >
                     <div className="ind-travel-icon">
                        <FlutterIcons />
                     </div>
                     <p className="ind-travel-text">Flutter App Development</p>
                  </Link>
                  <Link
                     href="/technologies/mobile/android-application-development-company"
                     className="ind-travel-icon-content"
                  >
                     <div className="ind-travel-icon">
                        <AndroiudIcon />
                     </div>
                     <p className="ind-travel-text">Android App Development</p>
                  </Link>
                  <Link
                     href="/technologies/mobile/ios-application-development-company"
                     className="ind-travel-icon-content"
                  >
                     <div className="ind-travel-icon">
                        <IphoneIcon />
                     </div>
                     <p className="ind-travel-text">iPhone App Development</p>
                  </Link>
                  <div className="ind-travel-icon-content">
                     <div className="ind-travel-icon">
                        <UiIcons />
                     </div>
                     <p className="ind-travel-text">UI/UX Design</p>
                  </div>
                  <Link
                     href="/services/web-design-services-company"
                     className="ind-travel-icon-content"
                  >
                     <div className="ind-travel-icon">
                        <WebDesignIcons />
                     </div>
                     <p className="ind-travel-text">Website Design</p>
                  </Link>
                  <Link
                     href="/technologies/frontend/vuejs-application-development-company"
                     className="ind-travel-icon-content"
                  >
                     <div className="ind-travel-icon">
                        <VueIcon />
                     </div>
                     <p className="ind-travel-text">vue jS Development</p>
                  </Link>
                  <Link
                     href="/technologies/qa-testing/automated-testing-services"
                     className="ind-travel-icon-content"
                  >
                     <div className="ind-travel-icon">
                        <QAIcons />
                     </div>
                     <p className="ind-travel-text">QA & Testing</p>
                  </Link>
               </div>
            </div>
         </div>
      </section>
   )
}
